import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import axios from "axios";

const Ctx = createContext({ values: {}, set: () => {}, editable: false, status: "idle" });
const API = `${process.env.REACT_APP_BACKEND_URL}/api/public/workbook`;

export function WorkbookProvider({ token, editable, children }) {
  const [values, setValues] = useState({});
  const [status, setStatus] = useState("idle");
  const timer = useRef(null);
  const latest = useRef({});
  const edited = useRef(false);

  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/${token}`).then((r) => {
      if (edited.current) return;
      latest.current = r.data.data || {};
      setValues(latest.current);
    }).catch(() => {});
  }, [token]);

  useEffect(() => {
    const flush = () => {
      if (!timer.current || !edited.current) return;
      clearTimeout(timer.current);
      timer.current = null;
      fetch(`${API}/${token}`, { method: "PUT", keepalive: true, headers: { "Content-Type": "application/json" }, body: JSON.stringify({ data: latest.current }) });
    };
    window.addEventListener("pagehide", flush);
    return () => window.removeEventListener("pagehide", flush);
  }, [token]);

  const set = useCallback((key, val) => {
    if (!editable || !token) return;
    edited.current = true;
    latest.current = { ...latest.current, [key]: val };
    setValues(latest.current);
    setStatus("saving");
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      timer.current = null;
      axios.put(`${API}/${token}`, { data: latest.current })
        .then(() => setStatus("saved"))
        .catch(() => setStatus("error"));
    }, 800);
  }, [editable, token]);

  return <Ctx.Provider value={{ values, set, editable: Boolean(editable && token), status }}>{children}</Ctx.Provider>;
}

export const useWorkbook = () => useContext(Ctx);
